import { jwtDecode } from "jwt-decode";
import isTokenExpire from "./TokenValidity";

export const isAuthenticated = () => {
  let tokenValid = true;

  try {
    if (localStorage.getItem("compte_admin").replace(/[\""]+/g, "")) {
      if (
        jwtDecode(localStorage.getItem("compte_admin").replace(/[\""]+/g, ""))
          .exp &&
        isTokenExpire(localStorage.getItem("compte_admin"))
      ) {
        tokenValid = true;
      } else {
        tokenValid = false;
      }
    }
  } catch (error) {
    tokenValid = false;
  }
  return tokenValid;
};
